<template>
  <v-data-table no-data="пусто" no-data-text="пусто" no-results-text="ничего не найдено"
    :headers="headers"
    :items="activities"
    disable-pagination
    disable-filtering
    item-key="activityid"
    sort-by="orgtitle"
    group-by="orgtitle"
    hide-default-footer
    dense
  >
    <template v-slot:group.header="{ group }">
      <td>
        <b>{{ group }}</b>
      </td>
      <td>
        &nbsp;
      </td>
    </template>
    <template v-slot:item.sum="{ item }">
      <b v-if="item.sum === 0" class="amount-0">{{rubles(item.sum)}}</b>
      <b v-else :class="item.sum < 0 ? 'amount-minus' : 'amount-plus'">{{rubles(item.sum)}}</b>
    </template>
    <template v-slot:footer>
      <tr>
        <td></td><td></td>
      </tr>
      <tr>
        <td>
          Дата формирования отчёта: <b>{{ today }}</b>
        </td>
        <td></td>
      </tr>
    </template>
  </v-data-table>
</template>

<script>
import moment from 'moment'
export default {
  name: 'ReportList',
  props: [ 'report' ],
  data: () => ({
    today: moment().format('YYYY-MM-DD HH:mm'),
    headers: [
      { text: 'Организация', value: 'orgtitle', sortable: false },
      { text: 'Организация / Вид деятельности', value: 'title', sortable: false },
      { text: 'Итог за период', value: 'sum', align: 'right', sortable: false }
    ],
  }),
  methods: {
    rubles (kops) {
      return (parseFloat(kops) / 100).toFixed(2)
    }
  },
  computed: {
    activities () {
      if (!this.report) return []
      const activities = this.report
      .filter(x => x.orgid !== 'migration')
      .reduce((r, org) => {
        r = [
          ...r,
          ...org.activities.map(x => {
            x.orgtitle = org.showorder + ' - ' + org.title + ' - ' + org.description
            return x
          })
        ]
        return r
      }, [])
      return activities
    }
  },
}
</script>

<style lang="css" scoped>
</style>
